import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Loading from '../Loading/Loading';

import * as Cookie from '../../utils/cookies';

function InvitedToGroup(props) {
  const { leagueId, groupId } = useParams();
  const { invited, setInvited } = props;
  const history = useHistory();

   React.useEffect(() => {
     if (invited === null) {
       setInvited({ league: leagueId, group: groupId });
       // Persist invited state to sessionStorage for resilience
       sessionStorage.setItem('invited', JSON.stringify({ league: leagueId, group: groupId }));
     } else {
      if (Cookie.getToken()) {
        history.push('/redirect');

      } else {
        history.push('/signin-sms');
      }
    }
  }, [invited, leagueId, groupId, setInvited, history]);

  return (
    <div>
      <Loading />
    </div>
  );
}

export default InvitedToGroup;
